<div class="h-100 d-flex flex-column" *ngIf="questiontree && hospi">
  <app-title></app-title>

  <div class="flex-grow-1" style="overflow: auto">
    <mat-card class="col-12 col-md-11" style="margin: auto">
      <p class="lead text-center">
        {{ "HOSPI_DECLARATION_ALREADY_DONE" | translated }}
        {{ hospi.creationDate | date: "dd/MM/yyyy à HH:mm" }}
      </p>
      <div class="mb-3" [innerHTML]="msgToShow | safeHtml"></div>
      <div *ngIf="questiontree && questiontree.length > 0">
        <u>{{ "PREVIOUS_RESPONSE" | translated }}</u>
        <dl>
          <ng-container *ngFor="let question of questiontree">
            <dt>{{ question?.question.textToDisplay }}</dt>
            <dd>{{ question?.answer.textToDisplay }}</dd>
          </ng-container>
        </dl>
      </div>
      <p>
        {{ "ADMISSION_DATE" | translated }}:
        {{ hospi.hospiPlannedDate | date: "dd/MM/yyyy" }}
      </p>
      <div class="row">
        <div class="col-3 text-center">
          <fa-icon [icon]="'hospital'" [size]="'6x'"></fa-icon>
        </div>
        <div class="col-9">
          <b>{{ site["hospitalName" + language.languageCode] }}</b
          ><br />
          {{ site["addressText" + language.languageCode] }}<br />
          {{ city.postalCode }} {{ city["text" + language.languageCode] }}
        </div>
      </div>

      <div class="d-flex flex-row p-2 align-items-center mt-3" *ngIf="lightMessage">
        <div class="p-2">
          <fa-icon
            [icon]="['fas', 'circle']"
            size="2x"
            [style.color]="lightColor"
          ></fa-icon>
        </div>
        <div
          class="p-2 ml-3 lead"
          [style.color]="lightColor"
          [innerHTML]="lightMessage | safeHtml"
        ></div>
      </div>
    </mat-card>
  </div>

  <div
    class="row mt-3"
    *ngIf="
      insurer.insurerPreHospiAllowContinue ===
        InsurerPreHospiAllowContinueEnum.Warn && displayButtons
    "
  >
    <div class="col-6">
      <app-btn [dataTxt]="'NO'" (callback)="onClickRetour()"></app-btn>
    </div>
    <div class="col-6 text-right">
      <app-btn [dataTxt]="'YES'" (callback)="onClickOk()"></app-btn>
    </div>
  </div>
  <app-btn
    *ngIf="!displayButtons"
    [dataTxt]="'BACK_TO_HOME'"
    [classes]="'w-100 btnAnimation'"
    (callback)="onHome()"
    [icon]="'home'"
    [iconLocation]="'left'"
  ></app-btn>
</div>
